import React from "react";
const filterValidChildren = (children) => React.Children.toArray(children).filter((child) => {
  if (!React.isValidElement(child)) {
    return false;
  }
  const componentType = child.type;
  const isListItem = typeof componentType !== "string" && componentType.displayName === "ListItem";
  return !isListItem || Boolean(child.props.children);
});
export {
  filterValidChildren
};
